export default __webpack_public_path__ + "static/media/scroll-image.4101d56d.jpg";